import { render, staticRenderFns } from "./PositionSlotsModal.vue?vue&type=template&id=dae2fccc&scoped=true"
import script from "./PositionSlotsModal.vue?vue&type=script&lang=js"
export * from "./PositionSlotsModal.vue?vue&type=script&lang=js"
import style0 from "./PositionSlotsModal.vue?vue&type=style&index=0&id=dae2fccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae2fccc",
  null
  
)

export default component.exports